import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7040efe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center flex items-center justify-center min-h-screen" }
const _hoisted_2 = { class: "signup-form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "xr-icon-xarcade",
    style: {"font-size":"60px"}
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "mb-4 text-white"
}
const _hoisted_5 = {
  key: 1,
  class: "mb-4 text-white"
}
const _hoisted_6 = { class: "form-group mb-2" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { class: "input-group-prepend" }
const _hoisted_9 = { class: "input-group-text" }
const _hoisted_10 = ["type"]
const _hoisted_11 = {
  key: 2,
  class: "alert alert-danger my-3 p-2",
  role: "alert"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  type: "submit",
  class: "btn-primary-full",
  style: {"font-size":"16px"}
}
const _hoisted_15 = {
  key: 3,
  class: "flex justify-between my-5"
}
const _hoisted_16 = { class: "form-group login-group-checkbox" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "lg_remember",
  class: "mx-2 text-gray-text text-sm"
}, "Remember me", -1))
const _hoisted_18 = { class: "forgot-password" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Forgot Password?")
const _hoisted_20 = { class: "form-group mt-3" }
const _hoisted_21 = {
  key: 1,
  class: "btn-primary-full",
  style: {"font-size":"16px"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-4 text-gray-text" }, "No account yet?", -1))
const _hoisted_23 = { class: "text-blue-primary" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Click here to Sign Up  ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_authFooter = _resolveComponent("authFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _hoisted_3,
        ($setup.activeSection == 'username' || $setup.activeSection == 'loadingUsername')
          ? (_openBlock(), _createElementBlock("h5", _hoisted_4, "Developer Sign In"))
          : _createCommentVNode("", true),
        ($setup.activeSection == 'login' || $setup.activeSection == 'loadingLogin')
          ? (_openBlock(), _createElementBlock("h5", _hoisted_5, "Welcome, " + _toDisplayString($setup.login.username) + "!", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                ($setup.activeSection == 'username' || $setup.activeSection == 'loadingUsername')
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: "fa-solid fa-user",
                      class: "text-blue-primary small opacity-75"
                    }))
                  : _createCommentVNode("", true),
                ($setup.activeSection == 'login' || $setup.activeSection == 'loadingLogin')
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      icon: "fa-solid fa-lock",
                      class: "text-blue-primary opacity-75"
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            ($setup.activeSection == 'username' || $setup.activeSection == 'loadingUsername')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 0,
                  type: "text",
                  class: "form-control",
                  name: "username",
                  placeholder: "Username",
                  required: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.login.username) = $event))
                }, null, 512)), [
                  [_vModelText, $setup.login.username]
                ])
              : _createCommentVNode("", true),
            ($setup.activeSection == 'login' || $setup.activeSection == 'loadingLogin')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  type: $setup.showPassword?'text':'password',
                  class: "form-control",
                  name: "Password",
                  placeholder: "Password",
                  required: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.login.password) = $event))
                }, null, 8, _hoisted_10)), [
                  [_vModelDynamic, $setup.login.password]
                ])
              : _createCommentVNode("", true),
            ($setup.activeSection == 'login' || $setup.activeSection == 'loadingLogin')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: "btn btn-showPassword",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showPassword = !$setup.showPassword))
                }, [
                  ($setup.showPassword)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: "fa-solid fa-eye-slash",
                        class: "text-gray-text"
                      }))
                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        icon: "fa-solid fa-eye",
                        class: "text-gray-text"
                      }))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        ($setup.errorSection === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass([!$setup.login.username ? 'opacity50' : ''])
          }, [
            ($setup.activeSection == 'username')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.retrieveXarcadeUser && $setup.retrieveXarcadeUser(...args))),
                  disabled: !$setup.login.username.trim(),
                  type: "submit",
                  class: "btn-primary-full",
                  id: "next-button",
                  style: {"font-size":"16px"}
                }, " Next ", 8, _hoisted_13))
              : _createCommentVNode("", true)
          ], 2),
          ($setup.activeSection == 'loadingUsername')
            ? (_openBlock(), _createElementBlock("button", _hoisted_14, "Loading..."))
            : _createCommentVNode("", true)
        ]),
        ($setup.activeSection == 'login' || $setup.activeSection == 'loadingLogin')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "lg_remember",
                  name: "lg_remember",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.remember_username) = $event))
                }, null, 512), [
                  [_vModelCheckbox, $setup.remember_username]
                ]),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_router_link, {
                  to: { name: 'viewAuthResetPassword' },
                  class: "text-blue-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          ($setup.activeSection == 'login')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.loginUser && $setup.loginUser(...args))),
                class: "btn-primary-full",
                style: {"font-size":"16px"}
              }, "Sign In"))
            : _createCommentVNode("", true),
          ($setup.activeSection == 'loadingLogin')
            ? (_openBlock(), _createElementBlock("button", _hoisted_21, "Loading..."))
            : _createCommentVNode("", true)
        ]),
        _hoisted_22,
        _createElementVNode("p", _hoisted_23, [
          _createVNode(_component_router_link, {
            to: {name: 'viewAuthSignup'},
            class: "text-blue-primary"
          }, {
            default: _withCtx(() => [
              _hoisted_24,
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-long-arrow-right",
                class: "inline-block"
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_authFooter, { activeSection: $setup.activeSection }, null, 8, ["activeSection"])
      ])
    ])
  ]))
}